import styled from 'styled-components';
import Button from '@mlb/react-patterns/v4/components/Button/button';
import { AnchorElement } from '@mlb/react-patterns/v4/components/Link/link.style';

export const HighlightsButton = styled(Button)`
    font-family: var(--gameday-primary-font);
    border-radius: 40px;
    font-size: 16px;
    height: 45px;
    width: ${({ $isMobile }) => $isMobile ? '90%' : '186px;'};
    background: var(--gameday-button-solid-background);
`;

export const HighlightsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: ${({ $isMobile }) => $isMobile ? '5px 0px 0px 0px' : '5px 0px var(--gameday-section-margin-sm) 0px'};
    flex-flow: ${({ $isMobile }) => $isMobile ? 'column' : 'row'};

    button:last-of-type {
        margin: ${({ $isMobile }) => $isMobile ? 'var(--gameday-section-margin-sm) 0' : '0px 25px'};
    }

    ${AnchorElement} {
        width: ${({ $isMobile }) => $isMobile ? '90%' : '186px;'};
        button {
            background: var(--gameday-button-hollow-background);
            color: var(--gameday-button-hollow-text);
            border-color: var(--gameday-button-hollow-border);
            width: ${({ $isMobile }) => $isMobile ? '100%' : '186px;'};
            margin: ${({ $isMobile }) => $isMobile ? '0px 0px var(--gameday-section-margin-sm) 0' : '0'};
            border: 1px solid;

            svg {
                transform: translateY(1px);
                fill: var(--gameday-button-hollow-text);
                path {
                    fill: var(--gameday-button-hollow-text);
                }
            }

            &:hover {
                color: var(--gameday-button-hollow-text);
                border-color: var(--gameday-button-hollow-border);
                svg {
                    fill: var(--gameday-button-hollow-text);
                    path {
                        fill: var(--gameday-button-hollow-text);
                    }
                }
            }
        }
    }
`;

export const HighlightsDivider = styled.div`
    width: calc(100% - 32px);
    height: 1px;
    background: var(--gameday-divider-color);
    display: block;
    margin: 0 auto;
    margin-bottom: var(--gameday-section-margin-sm);
    visibility: hidden;
`;
